module.exports = __webpack_public_path__ + "static/media/davinci-resolve.0be736e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FreelancerChooser/davinci-resolve.svg
// module id = 2077
// module chunks = 0